'use client';
import React from 'react';
export default function HomePage() {
  return (
    <div className="h-full w-full flex justify-center items-center text-black text-6xl">
      404: Page Not Found
    </div>
  );
}
